export function formatValueConversion(labelValue: number, locale: string, formatBy = '', fraction = 0): string {
  fraction = fraction >= 0 && fraction <= 9 ? fraction : 0;
  let maxFraction = fraction;
  if (formatBy === 'Automatic') {
    fraction = 0;
    maxFraction = 1;
    if (Math.abs(labelValue) / 1000000000 >= 1) {
      formatBy = 'B';
    } else if (Math.abs(labelValue) / 1000000 >= 1) {
      formatBy = 'M';
    } else if (Math.abs(labelValue) / 1000 >= 1) {
      formatBy = 'K';
    } else {
      formatBy = '';
    }
  }
  if (formatBy === 'B') {
    return `${(Number(labelValue) / 1.0e9).toLocaleString(locale, {
      minimumFractionDigits: fraction,
      maximumFractionDigits: maxFraction,
    })}B`;
  } else if (formatBy === 'M') {
    return `${(Number(labelValue) / 1.0e6).toLocaleString(locale, {
      minimumFractionDigits: fraction,
      maximumFractionDigits: maxFraction,
    })}M`;
  } else if (formatBy === 'K') {
    return `${(Number(labelValue) / 1.0e3).toLocaleString(locale, {
      minimumFractionDigits: fraction,
      maximumFractionDigits: maxFraction,
    })}K`;
  } else if (formatBy === '') {
    return Number(labelValue).toLocaleString(locale, {
      minimumFractionDigits: fraction,
      maximumFractionDigits: maxFraction,
    });
  }

  return 'n/a';
}
